import React from "react";
import { faCancel } from "@fortawesome/free-solid-svg-icons";
import { ToolButton } from "../../../../components";
import { IToolButtonProps } from "../../../../interfaces";
import { ToolbarContextEnum } from "../../../../enums";

export default function CancelButton({ config, item }: IToolButtonProps) {
  const { id: moduleId } = config;
  const { _id: itemId } = item;
  const isNew = config.context === ToolbarContextEnum.CreateItem;

  return (
    <ToolButton
      text="Cancel"
      icon={faCancel}
      path={isNew ? `/${moduleId}` : `/${moduleId}/${itemId}`}
    />
  );
}
